import React, {useEffect, useRef, useState} from 'react';
import {validator} from "../commonmethod/ValidationChecker";
import {resolveTextAreaDisplayStyle} from "../commonmethod/simmsTextAreaStyle";
import {isEmpty} from "lodash";


/*
* Todo api로딩이 안된건지 값 자체가 없는건지 구분해서 skeleton 을 보여줘야 한다.
* */
function ITER_SimmsTextArea({onChange, onKeyDown, update, data, style, constraint, auth, clicked, setClicked, placeHolder}) {

    const [value, setValue] = useState(data);
    const [localClicked, setLocalClicked] = useState(false);
    const hasParentClickState = typeof setClicked === "function";
    const isClicked = hasParentClickState ? !!clicked : localClicked;
    const setClickState = hasParentClickState ? setClicked : setLocalClicked;

    useEffect(() => {
        setValue(data ?? "");
    }, [data]);

    const {updatedStyle, isRequiredError} = validator(constraint, value, style);
    const inputRef = useRef(null);
    const handleSpanClick = () => {
        setClickState(true);
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };
    const handleChange = (e) => {
        setValue(e.target.value)
        if(!update){
            onChange(e.target.value);
        }
    }

    const handleKeyDown = (e) => {
        if (e.keyCode === 13 && e.shiftKey) {
            e.preventDefault();
            const { selectionStart, selectionEnd, value: currentValue } = e.target;
            const newValue = currentValue.slice(0, selectionStart) + "\n" + currentValue.slice(selectionEnd);

            setValue(newValue);
            return;
        }

        if(!update) return;

        if (e.key === "Escape") {
            setValue(data);
            setClickState(false);
            return;
        }

        // enter 시 blur처리
        if (e.key === "Enter") {
            e.preventDefault();
            inputRef.current?.blur();
        }
    }

    // blur시 update
    const handleBlur = (e) => {
        // 공백비교
        if(isEmpty(data) && isEmpty(value)) {
            setClickState(false);
            return;
        }

        // 데이터비교
        if(data === value){
            setClickState(false);
            return;
        }

        // 수정페이지에서만 사용
        // eslint-disable-next-line no-restricted-globals
        if(confirm("수정하시겠습니까?")) {
            if (update) onKeyDown(value, e);
        }else{
            setValue(data ?? "");
        }

        setClickState(false);
    }

    const fieldEditable = !update || !!auth;
    const showInput = !update || (!!auth && isClicked);
    const displayStyle = resolveTextAreaDisplayStyle(
        {
            ...(updatedStyle || {}),
            padding: "4px 12px",
            whiteSpace: "pre-wrap",
            lineHeight: "1.45",
        },
        data,
        value,
        {showInput},
    );

    return (
        <>
            {showInput ?
                <textarea
                    ref={inputRef}
                    type={"text"}
                    className={`basic-input ${!update ? 'input-style' :''}`}
                    style={displayStyle}
                    onBlur={handleBlur}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                />
                :
                <span
                    className={
                        fieldEditable
                            ? "edit-input inline-block asset-detail-kv-value--multiline overflow-y-auto text-left"
                            : "asset-detail-kv-value inline-block asset-detail-kv-value--multiline overflow-y-auto text-left"
                    }
                    style={resolveTextAreaDisplayStyle(
                        {
                            ...(style || {}),
                            padding: "4px 12px",
                            whiteSpace: "pre-wrap",
                            lineHeight: "1.45",
                        },
                        data,
                        value,
                        {showInput: false},
                    )}
                    onClick={fieldEditable ? handleSpanClick : undefined}
                >
                    {placeHolder ?? data}
                </span>
            }
        </>
    );
}

export default ITER_SimmsTextArea;